<template>
  <basic-container>
    <div class="custom-title">
      <div class="custom-block tip">
        <p class="custom-block-title">{{ title }}</p>
      </div>
      <div class="return-list">
        <el-button icon="el-icon-back" size="mini" @click="returnIndex('/source/servicesite')"
          >返回列表</el-button
        >
      </div>
    </div>
    <!--展示地图区域-->
    <div class="amap-contain">
      <div id="amapContainer" class="map"></div>
    </div>

    <div class="website-contain">
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <span>区域信息</span>
          <el-button @click="pastPoints" style="float: right; padding: 3px 0" type="text"
            >粘贴电子围栏</el-button
          >
        </div>
        <el-form ref="form" :model="form" :rules="rules" size="small" label-width="120px">
          <el-form-item label="区 划" prop="adcode">
            <!-- <el-cascader
              ref="cascaderAddr"
              placeholder="试试搜索：请选择省/市/区"
              :options="items"
              clearable
              v-model="form.adcode"
              :props="{ checkStrictly: true, label: 'name', value: 'adcode' }"
              filterable
              @change="handleChange"
              style="width: 100%"
            /> -->
            <YdCityLevelSelector
              ref="cascaderAddr"
              placeholder="试试搜索：请选择省/市/区"
              v-model="form.adcode"
              @change="handleChange"
              :emitPath="true"
              styles="width: 100%"
              :showProvince="[]"
            />
          </el-form-item>
          <el-form-item label="地级归属" prop="areaManageId">
            <yd-city-select
              mode="1"
              v-model="form.areaManageId"
              placeholder="试试搜索：请选择地级归属"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="区 域" prop="name">
            <el-input
              type="textarea"
              id="tipinput"
              :rows="2"
              v-model="form.name"
              placeholder="请输入服务区域名称"
              style="width: 100%"
            />
          </el-form-item>

          <el-col>
            <el-form-item label="备 注" prop="remark">
              <el-input
                type="textarea"
                :rows="2"
                v-model="form.remark"
                placeholder="请输入备注内容"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="showType">
              <span slot="label">
                排除服务区域
                <el-tooltip content="用于排除特定区域营运" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-radio-group v-model="form.showType" :disabled="form.areaCoverageNo !== ''">
                <el-radio :label="false">是</el-radio>
                <el-radio :label="true">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col style="margin: 0 0 30px 30px" v-if="this.form.areaCoverageNo === ''">
            <el-button
              type="success"
              size="small"
              icon="el-icon-add-location"
              @click="drawPolygon"
              :disabled="drawing"
              >开始描点</el-button
            >
            <el-button
              type="danger"
              size="small"
              :disabled="endPolygoBtnDisable"
              icon="el-icon-location-information"
              @click="closeDrawPolygon"
              >结束描点</el-button
            >

            <el-button size="small" icon="el-icon-delete-location" @click="clearPolygon"
              >清空</el-button
            >
          </el-col>

          <el-col
            style="display: flex; justify-content: center; margin-bottom: 30px"
            v-if="this.form.areaCoverageNo !== ''"
          >
            <el-button
              type="success"
              size="small"
              :disabled="openEditDrawBtn"
              icon="el-icon-add-location"
              @click="editRectangle"
              >开始编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              :disabled="endEditDrawBtn"
              icon="el-icon-location-information"
              @click="closeRectangle"
              >结束编辑</el-button
            >

            <el-button size="small" icon="el-icon-delete-location" @click="clearEditPolygon"
              >清空</el-button
            >
          </el-col>

          <el-col style="display: flex; justify-content: flex-end">
            <el-form-item>
              <el-button size="small" type="danger" @click.stop="cancel">取消</el-button>

              <el-button size="small" type="primary" @click="handleSubmit" :loading="loading"
                >保存</el-button
              >
            </el-form-item>
          </el-col>
        </el-form>
      </el-card>
    </div>
    <el-dialog
      title="电子围栏经纬度"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-input
        :autosize="{ minRows: 4, maxRows: 14 }"
        placeholder="粘贴经纬度（从老系统复制而来），格式[{longitude: 102.000000, latitude: 25.000000]"
        type="textarea"
        v-model="fromPoints"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="formatPoints">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
  import { selectTreeMixins } from '@/mixins/selectTree'
  import { save, getInfo, update } from '@/api/service'
  let AMap = null
  let polyEditor = null
  let map = null
  let mouseTool = null
  export default {
    name: 'ServiceSiteInfo',
    mixins: [selectTreeMixins],
    data() {
      return {
        loading: false,
        title: '新增服务区域',
        initMap: {
          // 初始化地图属性
        },
        searchOption: {
          city: '',
          citylimit: true
        },
        map: null,
        district: null,
        districtObj: {
          // 省市区搜索对象
          proviceCode: '', // 省份编码
          cityCode: '', // 城市编码
          areaCode: '', // 区域编码
          polygons: [] // 多边形点
        },
        polyType: {
          // 绘画的点
          borderColor: '',
          fillOpacity: 0.5,
          fillColor: '#D93A49',
          strokeColor: '#FF0000',
          strokeWeight: 2,
          strokeOpacity: 1,
          strokeStyle: 'solid',
          zIndex: 50
        },
        polygonList: [], // 绘制图的点
        polyEditors: [], // 所有编辑对象数组
        savePolygon: [], // 保存点
        openEditDrawBtn: false, // 打开编辑
        endEditDrawBtn: true, // 结束编辑
        endPolygoBtnDisable: true, // 是否结束描点
        form: {
          adcode: [],
          areaManageId: '',
          areaCoverageNo: '', // 电子围栏编号
          provinceCode: '', // 省级编码
          areaCode: '', // 区级编码
          cityCode: '', // 市级编码
          city: '',
          id: 0,
          centerCode: '',
          centerLatitude: 0, // 中心点纬度
          centerLongitude: 0, // 中心点经度
          name: '', // 电子围栏名称
          remark: '', // 备注
          points: [], // 电子围栏经纬度
          showType: true // 排除服务区域  true可以下单区域，false不可下单区域
        },
        rules: {
          adcode: [{ required: true, message: '请选择区划', trigger: 'blur' }],
          areaManageId: [{ required: true, message: '请选择地级归属', trigger: 'blur' }],
          name: [{ required: true, message: '请输入区域名称', trigger: 'blur' }]
        },
        placeSearch: null,
        drawing: false,
        dialogVisible: false,
        fromPoints: '',
        editPoints: [], // 编辑后的坐标点
        editRectangType: '' // 电子围栏编辑类型
      }
    },
    beforeDestroy() {
      map = null
      polyEditor = null
      mouseTool = null
      AMap = null
    },
    mounted() {
      // 获取服务区域详情的Id
      const sid = this.$route.params && this.$route.params.id
      if (sid) {
        this.init(sid)
      } else {
        this.$nextTick(() => {
          const time = setInterval(() => {
            if (window.AMap) {
              clearInterval(time)
              this.intAmap(() => {
                // 加载行政区划
                this.initDistinct()
              })
            }
          }, 500)
        })
      }
    },
    methods: {
      formatPoints() {
        const { fromPoints } = this
        const pointsStr = fromPoints.replace(/\s*/g, '')
        if (pointsStr) {
          this.loadRectangle(this.getPoint(JSON.parse(pointsStr)))
        }
        this.handleClose()
      },
      handleClose() {
        this.dialogVisible = false
      },
      pastPoints() {
        this.dialogVisible = true
      },
      async init(areaCoverageNo) {
        await getInfo(areaCoverageNo).then((resp) => {
          if (resp.code !== 0) {
            return
          }
          this.form = { ...this.form, ...resp.data }
          const codeArr = []
          if (resp.data.provinceCode) {
            codeArr.push(Number(resp.data.provinceCode))
          }
          if (resp.data.cityCode) {
            codeArr.push(Number(resp.data.cityCode))
          }
          if (resp.data.areaCode) {
            codeArr.push(Number(resp.data.areaCode))
          }
          this.form.adcode = codeArr
          this.form.areaCoverageNo = areaCoverageNo
          this.$nextTick(() => {
            const time = setInterval(() => {
              if (window.AMap) {
                clearInterval(time)
                this.intAmap()
              }
            }, 500)
          })
        })
      },
      getPoint(points) {
        const paths = []
        if (points.length > 0) {
          // 兼容老的，去重
          const list = points.reduce((prev, cur) => {
            if (prev.findIndex((item) => item.longitude === cur.longitude) === -1) {
              prev.push(cur)
            }
            return prev
          }, [])
          list.forEach((item) => {
            paths.push([parseFloat(item.longitude), parseFloat(item.latitude)])
          })
        }
        return paths
      },
      // 地图初始化
      intAmap(callBack) {
        // 初始化地图
        AMap = window.AMap
        if (this.form.centerLongitude !== 0 && this.form.centerLatitude !== 0) {
          const lngLat = [this.form.centerLongitude, this.form.centerLatitude]
          this.title = '编辑服务区域'
          map = new AMap.Map('amapContainer', {
            center: lngLat,
            zoom: 14,
            pitch: 80,
            rotation: 0,
            buildingAnimation: false // 楼块出现是否带动画
          })
        } else {
          // 没有中心点时候默认设置到云滴总部
          map = new AMap.Map('amapContainer', {
            zoom: 14,
            pitch: 80,
            rotation: 0,
            buildingAnimation: false, // 楼块出现是否带动画
            resizeEnable: true // 自动定位到当前城市
          })
        }

        // 地图插件
        AMap.plugin(
          [
            'AMap.MouseTool',
            'AMap.PolyEditor',
            'AMap.ControlBar',
            'AMap.Geolocation',
            'AMap.DistrictSearch'
          ],
          () => {
            const options = {
              showButton: true, // 是否显示定位按钮
              buttonPosition: 'LB', // 定位按钮的位置
              buttonOffset: new AMap.Pixel(10, 20), // 定位按钮距离对应角落的距离
              showMarker: true, // 是否显示定位点
              showCircle: true, // 是否显示定位精度圈
              circleOptions: {
                // 定位精度圈的样式
                strokeColor: '#0093FF',
                noSelect: true,
                strokeOpacity: 0.5,
                strokeWeight: 2,
                fillColor: '#02B0FF',
                fillOpacity: 0.25
              },
              zoomToAccuracy: true // 定位成功后是否自动调整地图视野到定位点
            }
            // 加载行政区划
            this.initDistinct()
            const geolocation = new AMap.Geolocation(options)
            map.addControl(geolocation)
            geolocation.getCurrentPosition()
            // 加载已规划的电子围栏
            const { points = [] } = this.form
            if (points.length > 0) {
              this.loadRectangle(this.getPoint(points))
            }
          }
        )
        map.addControl(new AMap.ControlBar())
        if (callBack && typeof callBack == 'function') {
          callBack()
        }
        // 输入提示
        // const autoOptions = {
        //   input: 'tipinput'
        // }
        // const auto = new this.AMap.Autocomplete(autoOptions)
        // this.placeSearch = new this.AMap.PlaceSearch({
        //   map: map
        // }) // 构造地点查询类
        // this.AMap.event.addListener(auto, 'select', this.onSearchResult)// 注册监听，当选中某条记录时会触发
        // //点击搜索出的mark点事件
        // this.AMap.event.addListener(this.placeSearch, 'markerClick', function(e) {
        //   this.$emit('bMapDate', e.data.location.lng, e.data.location.lat)
        // })
      },
      // 搜索
      onSearchResult(e) {
        this.placeSearch.setCity(e.poi.adcode)
        this.placeSearch.search(e.poi.name) // 关键字查询查询
        this.form.centerCode = e.poi.adcode
        this.form.centerLongitude = e.poi.location.lng
        this.form.centerLatitude = e.poi.location.lat
        this.form.name = e.poi.name
      },

      // 绘制多边形
      drawPolygon() {
        if (this.drawing) {
          return
        }
        if (this.polygonList.length > 0) {
          this.$message.error('电子围栏已存在!')
          return
        }
        this.drawing = true
        this.endPolygoBtnDisable = false
        this.polygonList = []
        if (!mouseTool) {
          mouseTool = new AMap.MouseTool(map)
        }
        // 初始化编辑
        mouseTool.polygon({
          strokeColor: this.polyType.strokeColor,
          strokeStyle: this.polyType.strokeStyle,
          strokeOpacity: this.polyType.strokeOpacity,
          strokeWeight: this.polyType.strokeWeight,
          fillColor: this.polyType.fillColor,
          fillOpacity: this.polyType.fillOpacity
        })
        mouseTool.on('draw', this.drawEvent)
        // const that = this
        // mouseTool.on('draw', function (event) {
        //   const polygonItem = event.obj
        //   // const paths = polygonItem.getPath() // 取得绘制的多边形的每一个点坐标
        //   // const path = [] // 编辑的路径
        //   // paths.forEach((v) => {
        //   //   path.push([v.lng, v.lat])
        //   // })
        //   that.polygonList.push(polygonItem)
        //   console.log('polygonList:', that.polygonList)
        // })
      },
      drawEvent(event) {
        const polygonItem = event.obj
        this.polygonList.push(polygonItem)
      },
      // 清空地图上绘制的多边形
      clearPolygon() {
        map.clearMap() // 删除地图所有覆盖物
        map.remove(this.polygonList)
        this.polygonList = []
        this.form.points = []
      },

      // 清空地图上绘制的多边形
      clearEditPolygon() {
        this.openEditDrawBtn = false
        this.endEditDrawBtn = true
        map.clearMap() // 删除地图所有覆盖物
        map.remove(this.polygonList)
        this.polygonList = []
        this.form.points = []
        location.reload()
      },

      // 结束绘制多边形
      closeDrawPolygon() {
        this.endPolygoBtnDisable = true
        this.drawing = false
        mouseTool.close()
        mouseTool.off('draw', this.drawEvent)
        this.form.points = []
        for (let i = 0; i < this.polygonList.length; i++) {
          const op = this.polygonList[i].getOptions()
          // 表单保存坐标点
          op.path.forEach((item) => {
            const point = {
              latitude: item.lat,
              longitude: item.lng
            }
            this.form.points.push(point)
          })
        }
        // 获取多边形的坐标点
        //   const routePath = []
        //   op.path.forEach((item) => {
        //     routePath.push([item.lng, item.lat])
        //   })
        //   const savearr = {
        //     path: routePath,
        //     strokeColor: op.strokeColor,
        //     strokeOpacity: op.strokeOpacity,
        //     fillOpacity: op.fillOpacity,
        //     fillColor: op.fillColor,
        //     zIndex: op.zIndex
        //   }
        //   this.savePolygon.push(savearr)
        // }
        // const save = JSON.stringify(this.savePolygon)
        // sessionStorage.setItem('savePolygon', save)
      },

      handleChange(val) {
        const { path = [], pathLabels = [] } = val || {}
        this.form.provinceCode = path[0] || ''
        this.form.cityCode = path[1] || ''
        this.form.areaCode = path[2] || ''
        this.form.city = pathLabels.filter((item, index) => index !== 0).join('/')
        if (path.length > 0) {
          this.handleSearchDist(path)
        }
      },
      // 加载电子围栏
      loadRectangle(path) {
        const that = this
        const polygon = new AMap.Polygon({
          path,
          fillOpacity: 0.5,
          fillColor: '#D93A49',
          strokeColor: '#FF0000',
          strokeWeight: 2,
          strokeOpacity: 1,
          strokeStyle: 'solid',
          zIndex: 50
        })

        map.add(polygon)
        // 缩放地图到合适的视野级别
        map.setFitView([polygon])
        polyEditor = new AMap.PolyEditor(map, polygon)

        polyEditor.on('addnode', function (event) {
          console.info('触发事件：addnode', event)
          that.editRectangType = event.type
        })

        polyEditor.on('adjust', function (event) {
          console.info('触发事件：adjust', event)
          that.editRectangType = event.type
        })

        polyEditor.on('removenode', function (event) {
          console.info('触发事件：removenode', event)
          that.editRectangType = event.type
        })
        polyEditor.on('end', function (event) {
          console.info('触发事件： end', event)
          that.editPoints = []
          event.target.w.path.forEach((item) => {
            const point = {
              latitude: item.lat,
              longitude: item.lng
            }
            that.editPoints.push(point)
          })
        })
      },

      // 开始编辑围栏
      editRectangle() {
        const that = this
        polyEditor.open()
        that.openEditDrawBtn = true
        that.endEditDrawBtn = false
      },
      // 结束编辑围栏
      closeRectangle() {
        const that = this
        polyEditor.close()
        that.endEditDrawBtn = true
        that.openEditDrawBtn = false
      },
      // 初始化区划查询
      initDistinct() {
        // 行政区划查询
        const opts = {
          subdistrict: 1, // 返回下一级行政区
          showbiz: false // 最后一级返回街道信息
        }
        this.district = new AMap.DistrictSearch(opts) // 注意：需要使用插件同步下发功能才能这样直接使用
        this.district.search('中国', (status, result) => {
          if (status === 'complete') {
            this.getDistinctData(result.districtList[0])
          }
        })
      },
      // 省市区联动查询
      handleSearchDist(val) {
        const that = this
        // 清除地图上所有覆盖物
        for (let i = 0, l = that.districtObj.polygons.length; i < l; i++) {
          that.districtObj.polygons[i].setMap(null)
        }
        const adcode = val[val.length - 1]
        that.district.setExtensions('all')
        val.forEach((item, index) => {
          if (index === 0) {
            that.district.setLevel('province') // 行政区省级别
          }
          if (index === 1) {
            that.district.setLevel('city') // 行政区市级别
          }
          if (index === 2) {
            that.district.setLevel('district') // 行政区域级别
          }
        })
        // 按照adcode进行查询可以保证数据返回的唯一性
        that.district.search(adcode.toString(), (status, result) => {
          if (status === 'complete') {
            that.getDistinctData(result.districtList[0])
          }
        })
      },
      // 获取区划查询的数据
      getDistinctData(data) {
        const that = this
        // 获取朝阳区的边界信息
        const bounds = data.boundaries
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            // 生成行政区划polygon
            const polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.2,
              fillColor: '#CCF3FF',
              strokeColor: '#FF0000',
              strokeStyle: 'dashed'
            })
            map.add(polygon)
            that.districtObj.polygons.push(polygon)
          } // 地图自适应
          map.setFitView()
        }
      },

      // 保存电子围栏信息
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 先判断电子围栏编号是否为空，为空则为添加，不为空则为编辑操作
            if (this.form.areaCoverageNo !== '') {
              if (!this.form.points.length) {
                this.$message.error('电子围栏不能为空!')
                return
              }
              if (this.editPoints.length) {
                this.form.points = JSON.parse(JSON.stringify(this.editPoints))
              }
              if (!this.endEditDrawBtn) {
                this.$message.warning('请点击结束编辑电子围栏')
                return
              }
            } else {
              if (!this.polygonList.length) {
                this.$message.error('电子围栏不能为空!')
                return
              }
              if (!this.form.points.length) {
                this.$message.error('请先结束描点')
                return
              }
            }
            if (!this.form.showType) {
              this.$confirm('是否确认将对应区域作为排除运营服务区域,这将影响对应区域用户下单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.saveOrUpdate()
                })
                .catch(() => {
                  console.log('用户点击了取消')
                })
            } else {
              this.saveOrUpdate()
            }
          }
        })
      },
      saveOrUpdate() {
        this.loading = true
        if (this.form.areaCoverageNo !== '') {
          update(this.form)
            .then((resp) => {
              if (resp.code === 0) {
                this.$message.success('编辑成功')
                this.resetForm()
                this.returnIndex('/source/servicesite')
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          save(this.form)
            .then((resp) => {
              if (resp.code === 0) {
                this.$message.success('保存成功')
                this.resetForm()
                this.returnIndex('/source/servicesite')
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      // getNodeData(val) {
      //   console.log('val:', val)
      //   this.form.areaManageId = Number.parseInt(val.id)
      // },
      // 取消
      cancel() {
        this.resetForm()
        this.returnIndex('/source/servicesite')
      },
      // 清空表单数据
      resetForm() {
        this.form = {
          adcode: [],
          areaManageId: '',
          areaCoverageNo: '', // 电子围栏编号
          provinceCode: '', // 省级编码
          areaCode: '', // 区级编码
          cityCode: '', // 市级编码
          city: '',
          id: 0,
          centerCode: '',
          centerLatitude: 0, // 中心点纬度
          centerLongitude: 0, // 中心点经度
          name: '', // 电子围栏名称
          remark: '', // 备注
          points: [], // 电子围栏经纬度
          showType: true // 排除服务区域  true可以下单区域，false不可下单区域
        }
      },
      // 返回
      returnIndex(url) {
        this.$router.push({ path: url, query: { type: 'Refresh' } })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-title {
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-between;
    width: 100%;
    .custom-block.tip {
      border-color: #409eff;
      padding: 0.4rem 0 0 0.5rem;
      border-left-width: 0.3rem;
      border-left-style: solid;
      height: 26px;
      margin: 0rem 0;
    }
    .custom-block-title {
      font-weight: 600;
      margin: 0;
    }
    .return-list {
      justify-content: flex-end;
    }
  }
  .amap-contain {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 120vh;
    display: flex;
    margin-top: 20px;

    .map {
      width: 100%;
      height: 120vh;
    }
  }

  .website-contain {
    position: absolute;
    left: 50px;
    top: 90px;
    width: 58vh;
    display: flex;
    flex-direction: column;
  }
  .form-style {
    padding: 10px 0 0 10px;
  }
  .btn-style {
    padding: 0 0 0 94px;
  }
  ::v-deep .amap-icon img {
    width: 10px;
    height: 10px;
  }
</style>
